import {PropsWithChildren, useContext, useEffect, useRef} from "react";
import {Card, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {ProjectContext} from "../../ProjectProvider";
import {useSnackbar} from "../../../../misc/Snackbar";
import {useBackgroundAction} from "../../manage/sov/UseBackgroundTask";
import {api} from "../../../../api/API";

export function PausePricingCover(props: PropsWithChildren<{
    blank?: boolean;
}>) {

    const projectCtx = useContext(ProjectContext);
    const proj = projectCtx.value;

    if(proj?.quotePausePricing) {
        if(props.blank) return null;

        return (
            <AutoUnPausePricing />
        );
    }

    return props.children;
}

function AutoUnPausePricing() {

    const projectCtx = useContext(ProjectContext);
    const proj = projectCtx.value;

    const reloadRef = useRef(projectCtx.reload);
    reloadRef.current = projectCtx.reload;

    const snack = useSnackbar();
    const update = useBackgroundAction({
        callback: (input: Parameters<typeof api.projects.setPausePricing>[0]) => api.projects.setPausePricing(input),
        onDone: (value: {
            paused: boolean
        }) => {

            reloadRef.current();
            if(value.paused) {
                snack.success("Fast Mode enabled");
            } else {
                snack.success("Auto Pricing enabled");
            }
        },
    });

    const updateRef = useRef(update.callback);
    updateRef.current = update.callback;

    useEffect(() => {
        if(!proj.quotePausePricing) return;
        updateRef.current({
            project: proj.id,
            pause: false,
        });
    }, [proj]);

    return (
        <div style={{padding: 8, backgroundColor: grey["100"],
            flex: 1, display: "flex", justifyContent: "flex-start", alignItems: "flex-start"}}>
            <Card style={{padding: 16, width: 400}}>
                <Typography variant="h6">Products & Pricing are paused</Typography>
                <Typography variant="body1">
                    Sometimes people will pause these calculations to give a performance boost while
                    working in the openings section.
                </Typography>
                <div style={{height: 8}} />
                <div>
                    {update.LoadingElement}
                </div>
            </Card>
        </div>
    )
}